import React from "react";

import { Avatar, Stack, Typography } from "@mui/material";

interface Person {
  id: string;
  name: string;
  role: string;
  avatar: string;
}

interface SuggestedMember {
  id: string;
  name: string;
  role: string;
  company: string;
  location: string;
  bio: string;
  coverImage: string;
  avatar: string;
}

interface Props {
  people?: Person[];
  allMembers?: SuggestedMember[];
  onMemberClick?: (member: SuggestedMember) => void;
}

export const SuggestedMembers: React.FC<Props> = ({ people, allMembers, onMemberClick }) => {
  const defaultPeople: Person[] = [
    { id: "1", name: "Lucas Wilde", role: "Chief Technology Officer", avatar: "ec5f761f-10c3-4113-b292-b2d34d0a4558" },
    { id: "2", name: "Aiden Parker", role: "Marketing Chief", avatar: "9b5a54b5-bcc7-449d-9935-448e9b3e41fc" },
    { id: "3", name: "Nora Hayes", role: "Lead of Innovation", avatar: "b18cb277-e1b9-43ae-8463-d6afc5c9cd8d" },
    { id: "4", name: "Ethan Brooks", role: "Head of Technology", avatar: "c5c752f5-5ffd-4b3b-9f00-25870da1fcd1" },
    { id: "5", name: "Lucas Wilde", role: "Chief Technology Officer", avatar: "ec5f761f-10c3-4113-b292-b2d34d0a4558" }
  ];

  const displayPeople = people || defaultPeople;

  const handleMemberClick = (person: Person) => {
    if (onMemberClick && allMembers) {
      const fullMember = allMembers.find((member) => member.id === person.id);
      if (fullMember) {
        onMemberClick(fullMember);
      }
    }
  };

  return (
    <Stack
      sx={{
        bgcolor: "white",
        borderRadius: "8px",
        p: "16px",
        gap: "10px",
        boxShadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.1)"
      }}
    >
      <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#071f35", lineHeight: "24px" }}>
        People you may know
      </Typography>
      <Stack gap="10px">
        {displayPeople.map((person, index) => (
          <Stack
            key={person.id || index}
            direction="row"
            gap="10px"
            alignItems="flex-start"
            onClick={() => handleMemberClick(person)}
            sx={{
              borderBottom: index < displayPeople.length - 1 ? "1px solid #dbe8f5" : "none",
              pb: index < displayPeople.length - 1 ? "10px" : 0,
              cursor: onMemberClick ? "pointer" : "default",
              p: onMemberClick ? "4px" : 0,
              margin: onMemberClick ? "-4px" : 0,
              borderRadius: onMemberClick ? "4px" : 0,
              transition: "background-color 0.2s ease",
              "&:hover": onMemberClick
                ? {
                    bgcolor: "#f5f5f5"
                  }
                : {}
            }}
          >
            <Avatar src={`https://www.figma.com/api/mcp/asset/${person.avatar}`} sx={{ width: 40, height: 40 }} />
            <Stack flex={1}>
              <Typography sx={{ fontSize: "15px", fontWeight: 500, color: "#000", lineHeight: "20px" }}>
                {person.name}
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#496682", lineHeight: "16px" }}>
                {person.role}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Typography
          component="a"
          href="#"
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#26a6ae",
            textDecoration: "none",
            cursor: "pointer"
          }}
        >
          See all members
        </Typography>
      </Stack>
    </Stack>
  );
};
